import { Box, Button, Modal } from '@palmetto/palmetto-components';

import { SalesRepCheckReason } from 'types';

export interface ContractSendReasonsModalProps {
  reasons: SalesRepCheckReason[];
  onClose: () => void;
}

const DETAIL_LABELS = [
  ['licenseNumber', 'License number'],
  ['licenseStatus', 'License status'],
  ['expirationDate', 'Expiration date'],
] as const;

/** Explains why a contract could not be sent, with the action the sales rep needs to take for each reason. */
export function ContractSendReasonsModal({ reasons, onClose }: ContractSendReasonsModalProps) {
  return (
    <Modal isOpen onDismiss={onClose} maxWidth="4xl" ariaLabelledBy="contractSendReasonsTitle" fullScreenMobile>
      <Modal.Header id="contractSendReasonsTitle" title="Unable to send contract" onDismiss={onClose} />
      <Modal.Body background="secondary" childGap="lg">
        {reasons.map((reason) => (
          <Box key={`${reason.code}-${reason.message}`} childGap="xs" data-testid="send-reason">
            <Box fontSize="sm" fontWeight="bold" color="body-primary">
              {reason.message}
            </Box>
            <Box fontSize="sm" color="body-secondary">
              {reason.resolution}
            </Box>
            {DETAIL_LABELS.map(([key, label]) =>
              reason.details?.[key] ? (
                <Box key={key} fontSize="sm" color="body-secondary">
                  {label}: {reason.details[key]}
                </Box>
              ) : null,
            )}
          </Box>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Box display="flex" direction="row" justifyContent="flex-end" width="100">
          <Button type="button" variant="primary" size="md" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Modal.Footer>
    </Modal>
  );
}
